import { render, staticRenderFns } from "./schoolscores.vue?vue&type=template&id=832919d2&scoped=true"
import script from "./schoolscores.vue?vue&type=script&lang=js"
export * from "./schoolscores.vue?vue&type=script&lang=js"
import style0 from "./schoolscores.vue?vue&type=style&index=0&id=832919d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832919d2",
  null
  
)

export default component.exports